<div class="live-region" [ngClass]="{'visually-hidden': !isVisible }" aria-live="assertive" role="log" aria-relevant="additions" aria-atomic="true">
  <div class="live-region-message" *ngFor="let message of (messages$ | async)">{{ message }}</div>
</div>
